module.exports = __webpack_public_path__ + "img/ticket-bg-x.df7f11a.png";